import { Button, Spinner } from "@king-ict/eupisi-ui/components";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../hooks";

export function LoginMenu() {
  const { t } = useTranslation();

  const auth = useAuth();

  if (auth.isLoading) {
    return <Spinner show={true} />;
  }

  return (
    <Container className="pt-5">
      <Card className="m-5" border="info" bg="light">
        <Card.Header className="text-center h4">PRIJAVA U SUSTAV</Card.Header>
        <Card.Body>
          <Card.Title className="pb-2">
            {t("login.welcomeMessageTitle")}
          </Card.Title>

          <ListGroup variant="flush">
            {process.env.REACT_APP_ENV !== "PROD" && (
              <ListGroup.Item>
                <Row>
                  <Col xl="4">Prijava putem TEST sustava</Col>
                  <Col>
                    <Button
                      onClick={() =>
                        auth.login({
                          redirectUri: process.env.REACT_APP_WEB_PUBLIC,
                        })
                      }
                      outline={true}
                      size="sm"
                    >
                      {t("login.loginButton")}
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            )}
            <ListGroup.Item>
              <Row>
                <Col xl="4">Prijava putem NIAS sustava</Col>
                <Col>
                  <Button
                    onClick={() =>
                      auth.login({
                        idpHint: process.env.REACT_APP_KEYCLOAK_IDPHINT,
                        redirectUri: process.env.REACT_APP_WEB_PUBLIC,
                      })
                    }
                    outline={true}
                    size="sm"
                  >
                    {t("login.loginButton")}
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col xl="4">Prijava putem AAI edu.hr sustava</Col>
                <Col>
                  <Button
                    onClick={() =>
                      auth.login({
                        idpHint: process.env.REACT_APP_KEYCLOAK_AAI_IDPHINT,
                        redirectUri: process.env.REACT_APP_WEB_PUBLIC,
                      })
                    }
                    outline={true}
                    size="sm"
                  >
                    {t("login.loginButton")}
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}
